// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueCropper from 'vue-cropper'
import './utils/rem.js'
// import 'default-passive-events';
Vue.use(VueCropper)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

Vue.config.productionTip = false


import Service from '@/utils/fetch'

Vue.prototype.$axios = Service


import { Tools } from "@/utils/utils";

Vue.prototype.$binyiTool = Tools
Vue.prototype.$Message = ElementUI.Message;
Vue.prototype.$MessageBox = ElementUI.MessageBox;
Vue.prototype.$Confirm = ElementUI.MessageBox.confirm;

import '@/assets/iconfont/iconfont.css';

import longpress from './utils/longpress.js'
Vue.directive('longpress', longpress)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js